import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { Translate } from '../../WithTranslate';
import { Card } from '@blueprintjs/core';
import { DivLine } from '../../styledComponents/StyledComponents';
import { Page, TLCode } from '../../../../common/enums';
import { Pharmacy } from '../../../../store/models';

interface SharedDutiesGroupInformationProps {
  allPharmaciesInGroup: Array<Instance<typeof Pharmacy>>;
  translate: Translate;
  navigate: (path: string) => void;
}

export const SharedDutiesGroupInformation = ({
  allPharmaciesInGroup,
  translate,
  navigate,
}: SharedDutiesGroupInformationProps) => {
  return (
    <>
      <Card
        style={{
          margin: 4,
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          flex: 1,
          maxHeight: '30px',
        }}
      >
        <DivLine style={{ flexWrap: 'wrap' }}>
          <p style={{ color: 'red' }}>
            {translate(TLCode.PHARMACY_Calendar_SharedDutiesGroup_Info)}
            {allPharmaciesInGroup
              .map((p) => {
                return <span onClick={() => navigate(`${Page.PharmacyPage}/${p.pharmacyId}`)}>{p.name}</span>;
              })
              .reduce(
                (accu, elem) => {
                  return accu === null ? [elem] : [...accu, <>{', '}</>, elem];
                },
                null as Array<JSX.Element> | null,
              )}
          </p>
        </DivLine>
      </Card>
    </>
  );
};
